import { render, staticRenderFns } from "./onHook.vue?vue&type=template&id=fac4315c&scoped=true&"
import script from "./onHook.vue?vue&type=script&lang=js&"
export * from "./onHook.vue?vue&type=script&lang=js&"
import style0 from "./onHook.vue?vue&type=style&index=0&id=fac4315c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac4315c",
  null
  
)

export default component.exports